import { constants } from "../constants";
import { StringFormat } from "../Util/stringutil";
import { Stat, Status } from "./entity/statusEntity";
import { myFetch } from "./myFetch";
import {
  InsertScheduleTemplateResponse,
  ResponseScheduleTemplateResponse,
  ScheduleTemplate,
} from "./entity/ScheduleTempOperationEntity";

// Interface for the Corporation API calls...
export default interface IScheduleTempOperation {
  postScheduleTempAsync(
    corpId: number,
    template: ScheduleTemplate
  ): Promise<Stat<InsertScheduleTemplateResponse>>;

  putScheduleTempAsync(
    corpId: number,
    templateId: number,
    template: ScheduleTemplate
  ): Promise<Status>;

  deleteScheduleTempAsync(corpId: number, templateId: number): Promise<Status>;

  getScheduleTempAsync(
    corpId: number,
    page: number,
    pageSize: number
  ): Promise<ResponseScheduleTemplateResponse>;
}

export class ScheduleTempOperation implements IScheduleTempOperation {
  async getScheduleTempAsync(
    corpId: number,
    page: number,
    pageSize: number
  ): Promise<ResponseScheduleTemplateResponse> {
    const response = await myFetch<ResponseScheduleTemplateResponse>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_SCHEDULE_TEMP_ENDPOINT,
        corpId,
        page,
        pageSize
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    if (response.status === 200) {
      const data = await response.json();
      return data;
    }
    return {
      results: [],
      currentPage: 1,
      pageCount: 0,
      pageSize: 0,
      rowCount: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
    };
  }

  async putScheduleTempAsync(
    corpId: number,
    templateId: number,
    template: ScheduleTemplate
  ): Promise<Status> {
    const response = await myFetch<Stat<InsertScheduleTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.PUT_SCHEDULE_TEMP_ENDPOINT,
        corpId,
        templateId
      )}`,
      {
        method: "PUT",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(template),
      }
    );

    const data = await response.json();
    return data;
  }

  async deleteScheduleTempAsync(
    corpId: number,
    templateId: number
  ): Promise<Status> {
    const response = await myFetch<Stat<InsertScheduleTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.DELETE_SCHEDULE_TEMP_ENDPOINT,
        corpId,
        templateId
      )}`,
      {
        method: "DELETE",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify({}),
      }
    );

    const data = await response.json();
    return data;
  }
  async postScheduleTempAsync(
    corpId: number,
    template: ScheduleTemplate
  ): Promise<Stat<InsertScheduleTemplateResponse>> {
    const response = await myFetch<Stat<InsertScheduleTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_SCHEDULE_TEMP_ENDPOINT,
        corpId
      )}`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(template),
      }
    );

    const data = await response.json();
    return data;
  }
  /*async postTimeOffReasonAsync(
    corpId: number,
    requestBody: InsertTimeOffReasonRequest
  ): Promise<Status> {
    const response = await myFetch<Stat<TimeOffStatistics>>(
      `${constants.BASE_URL}${StringFormat(
        constants.POST_TIMEOFF_REASON,
        corpId
      )}`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(requestBody),
      }
    );

    const data = await response.json();
    return data;
  }

  async getTimeOffStatAsync(corpId: number): Promise<Stat<TimeOffStatistics>> {
    const response = await myFetch<Stat<TimeOffStatistics>>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_TIMEOFF_STAT_ENDPOINT,
        corpId
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    const data = await response.json();
    return data;
  }

  async getScheduleTimeOffAsync(
    corpId: number,
    reqTimeOffPram: RequestTimeOffParam
  ): Promise<ResponseTimeOffRequest> {
    const querystring = Object.entries(reqTimeOffPram)
      .map(([key, value]) => key + "=" + value)
      .join("&");
    const response = await myFetch<ResponseTimeOffRequest>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_TIMEOFF_ENDPOINT,
        corpId
      )}?${querystring}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    if (response.status === 200) {
      const data = await response.json();
      return data;
    }
    return {
      results: [],
      currentPage: 1,
      pageCount: 0,
      pageSize: 0,
      rowCount: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
    };
  }*/
}
